
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { BreadCrumpActions } from "../actions/table_actions";
import {userdata} from "../typing/table_typing";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";


interface testdataResponsePayloadInterface{
    data:{
    entry:userdata,
    link:userdata,
    }
}



export const requestDataFromAPI =() => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/Support",
            {},
            "GET",
            (payload:testdataResponsePayloadInterface) => {
                console.log(payload);
                dispatch(
                    BreadCrumpActions.setCrumbs(
                         {
                             entry: payload.data.entry,
                             link: payload.data.link
                         }
                     )
                 );
            },
            ()=>{}
        ) as any)
    }
}
